import { Box, CircularProgress, Container, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import { I18nContext } from "../../I18nProvider";
import { useContext, useEffect, useState } from "react";
import IresearhService from "../../services/IresearchService";
import { ODS } from "../../Interface/IODS";

export const Odss: React.FC = () => {
    
    const [odss, setOdss] = useState<ODS[]>([]); 
    const context = useContext(I18nContext);
    const [loading, setLoading] = useState<boolean>(true); 

    if (context === null) {
        throw new Error(
            "The I18n context is not initialized. Make sure you have the provider set up correctly."
        );
    }


    useEffect(() => {
        IresearhService.getOds()
            .then((odsData: { listData: ODS[] }) => {
                
                const odsList = odsData.listData
                setOdss(odsList)
            })
            .catch((error) => {
                console.error("Error fetching user data from backend:", error);
            })
            .finally(() => {
                setLoading(false); 
            });
    }, []);

    return (
        <Container>
            <h1>{context.t.translate("home.ods")}</h1>
            {loading ? ( 
                <Box display="flex" justifyContent="center" alignItems="center" height="60vh">
                    <CircularProgress />
                </Box>
            ) : (
            <Grid container justifyContent="center" alignItems="center" sx={{ marginTop: "20px" }}>
                <Grid item xs={12} sm={10} md={10} container spacing={2} justifyContent="center" >

                    {odss.map((item) => {                        
                        const imagePath = require(`../../assets/img/ods/ods${item.idOds}.jpg`);
                        const ods_url = `/ods/${item.idOds}`
                        return (
                            <Grid item xs={4} sm={3} md={2} key={item.idOds}>
                                <Link to={ods_url} >
                                    <img src={imagePath} width="100%" alt={`ODS ${item.idOds}`} />
                                </Link>
                            </Grid>
                        );
                    })}
                </Grid>
             </Grid>
            )}
        </Container>
    );
};
